import React from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useVendasSuprimentos } from "./vendasData";

const SuprimentosVendas: React.FC = () => {
  const headers = [
    "PV",
    "Tipo",
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Cliente",
    "Responsável", // 👈 NOVO
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useVendasSuprimentos();

  const columnWidths = [
    "60px", // PV
    "80px", // Tipo
    "70px", // Código
    "300px", // Nome do Produto
    "60px", // Quantidade
    "100px", // Custo Unitário
    "160px", // Cliente
    "160px", // Responsável 👈 NOVO
    "90px", // Data
    "60px", // Hora
  ];

  return (
    <div>
      <TitleButtons
        title="Suprimentos - Vendas"
        buttons={
          [
            // {
            //   label: "Gerar Relatório",
            //   onClick: () => console.log("Relatório gerado"),
            //   variant: "secondary",
            // },
          ]
        }
      />
      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        isTableStandby
      />
    </div>
  );
};

export default SuprimentosVendas;
